import { http } from '@frontend/fetch';

export const updatePayoutDescriptor = ({ locationId, descriptor }: { locationId: string; descriptor: string }) => {
  return http.post(`payments/commands/service/merchant/payout-descriptor`, {
    merchantId: locationId,
    payoutDescriptor: descriptor,
  });
};
